import { CardSkeleton, Skeleton, Table, TableCard } from "@/shared/ui";

interface TableSkeletonProps {
  columns: number;
  rows: number;
}

export const TableSkeleton = ({ columns, rows }: TableSkeletonProps) => {
  return (
    <>
      <Table.Root>
        <Table.Header>
          <Table.Row className="pointer-events-none">
            {Array.from({ length: columns }).map((_, colIndex) => (
              <Table.Head key={colIndex}>
                <Skeleton className="h-full" />
              </Table.Head>
            ))}
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {Array.from({ length: rows }).map((_, rowIndex) => (
            <Table.Row key={rowIndex} className="pointer-events-none">
              {Array.from({ length: columns }).map((_, colIndex) => (
                <Table.Cell key={colIndex}>
                  <Skeleton className="h-full" />
                </Table.Cell>
              ))}
            </Table.Row>
          ))}
        </Table.Body>
      </Table.Root>

      <TableCard.Root>
        {Array.from({ length: rows }).map((_, rowIndex) => (
          <TableCard.Row key={rowIndex}>
            <CardSkeleton className="bg-transparent" />
          </TableCard.Row>
        ))}
      </TableCard.Root>
    </>
  );
};
